import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { openBuilder } from '../../config/builder';
import { MENU_ROUTES } from '../../constants';
import { Button, IconArrowRight as ArrowRight } from '../../core';
import { ReactComponent as Logo } from '../../images/dhcs.svg';
import HeaderNavigationStyled from '../HeaderNavigation';
import NewTabNote from '../NewTabNote';

interface Props {
  className?: string;
}

const Header = ({ className = '' }: Props) => (
  <div className={className}>
    <Link to={MENU_ROUTES.overview.path}>
      <Logo />
    </Link>

    <HeaderNavigationStyled />

    <Button onClick={openBuilder} variant="primary" size="M" iconAfter={<ArrowRight />}>
      Open Builder
      <NewTabNote />
    </Button>
  </div>
);

const HeaderStyled = styled(Header)`
  display: flex;
  position: relative;
  z-index: 20;
  background-color: ${({ theme }) => theme.neutralBackgroundMedium};
  padding: 0 1.25rem;
  height: 4rem;
  grid-area: header;
  align-items: center;
  justify-content: space-between;
`;

export default HeaderStyled;
